export const environment = {
  production: false,
  baseAPIURL: 'https://api.qa.lios.toyota.com/aet/api/v1',
  TENANT_ID: 'https://login.microsoftonline.com/tmnatest.onmicrosoft.com',
  CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
  REDIRECT_URL: 'https://aet.qa.lios.toyota.com',
  LIOS_HOME_URL: 'https://qa.lios.toyota.com/home',
  LOGOUT_REDIRECT_URL: 'https://qa.lios.toyota.com/',
  agGridLicenseKey: 'Using_this_{AG_Grid}_Enterprise_key_{AG-095410}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyota}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{7}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_January_2027}____[v3]_[01]_MTgwMDIzMDQwMDAwMA==46ac1b6b703b45287199e386ca8d5f25',
  APM_DS_URI: 'https://api.qa.lios.toyota.com/apm/graphql',
  SCOPES: ['https://tmnatest.onmicrosoft.com/e45b42dc-670d-4640-b95b-a24d12e73448/user_impersonation'],
  FILE_UPLOAD_URI: "https://upload.qa.lios.toyota.com",
  TEMPLATE_EXCEL_URI: "https://template.qa.lios.toyota.com",
  WEBSOCKET_URI: "wss://v5tflp0a5k.execute-api.us-east-1.amazonaws.com/qa/",
  SENDMAIL_URL: "https://api.qa.lios.toyota.com/windowTimes/sendmail",
  TASK_MANAGER: 'https://taskmanager.qa.lios.toyota.com',
  AET: 'https://ts.stage.portal.toyotasupplier.com/aet',
  ALARMS: 'https://alarms.qa.lios.toyota.com',
  FORECAST_ADMIN_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/forecast',
  CO2: 'https://liosapps.qa.toyota.com/co2/lp-upload',
  COST_PLANNING: 'https://costplanning.qa.lios.toyota.com',
  EBOI: 'https://eboi.qa.lios.toyota.com',
  TLD: 'https://tld.qa.lios.toyota.com',
  DD: 'https://ts.stage.portal.toyotasupplier.com/lios/delayindex#/delayeddispatch',
  REPORTS: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=11db23f6-28df-4b47-bf4d-03bb6cab9246&ctid=8c642d1d-d709-47b0-ab10-080af10798fb&experience=power-bi',
  EXPORT: 'https://export.qa.lios.toyota.com',
  GROUPI: 'https://liosapps.qa.toyota.com/groupi',
  SCHEDULE_JOB: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
  RETURNS_RELOAD: 'https://ts.stage.portal.toyotasupplier.com/lios/routemgt',
  SCHEDULE_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
  TLMS_SEND: 'https://ts.stage.portal.toyotasupplier.com/lios/tlmssend',
  ALLO: 'https://allo.qa.lios.toyota.com',
};
